import React from 'react';

const StatCard = ({
  title,
  value,
  icon,
  change,
  changeType = 'up',
  className = ''
}) => {
  return (
    <div className={`stat-card ${className}`.trim()}>
      <div className="flex justify-between items-start">
        <div className="stat-label">{title}</div>
        {icon && <div className="stat-icon">{icon}</div>}
      </div>
      <div className="stat-value">{value}</div>
      {change && (
        <div className={`stat-change ${changeType}`}>
          {changeType === 'up' ? '↑' : '↓'} {change}
        </div>
      )}
    </div>
  );
};

export default StatCard;
